import '@babel/polyfill'
import { Provider } from 'mobx-react'
import React from 'react'
import ReactDOM from 'react-dom'
import { Router, withRouter } from 'react-router'
import 'whatwg-fetch'
import AppContainer from './app/app-container'
import './index.scss'
import { renderAppRoutes } from './routes'
import { createStore, history } from './store'
import { NAVIGATION_MENU_STORE } from './store/stores'
import { getStore } from './store/stores-repository'
import { appLaunchChain, appRenderer } from './utils/app-utils'
import ScrollToTop from './utils/scroll-to-top/scroll-to-top'

// TODO На данный момент необходимо в react router 4 для вызова перерисовки при смене location
const App = withRouter(AppContainer)

const renderApp = () => {
    const store = createStore()
    const navigationMenuStore = getStore(NAVIGATION_MENU_STORE)

    navigationMenuStore.init()
    navigationMenuStore.synchronizeWithRoute()

    ReactDOM.render(
        <Provider {...store}>
            <Router history={history}>
                <App>
                    <ScrollToTop />
                    {renderAppRoutes()}
                </App>
            </Router>
        </Provider>,
        document.getElementById('content')
    )
}

appRenderer.render = renderApp

appLaunchChain()
